import { TagType } from "./tags";

export enum FilterMatchingType {
  STRING_INCLUDES = 'StringIncludes',
  ARRAY_INCLUDES_PROPERTY = 'ArrayIncludesProperty',
  ARRAY_INCLUDES_PROPERTY_DROPDOWN = 'ArrayIncludesPropertyDropdown',
  ARRAY_INCLUDES_CUSTOMERS_DROPDOWN_LAZY = 'ArrayIncludesCustomersDropdownLazy',
  NUMBER_COMPARE = 'NumberCompare',
  DATE_RANGE = 'DateRange',
}

export interface Filter {
  name: string;
  path?: string[];
  label: string;
  matching: FilterMatchingType;
  key?: string;
  value: any;
  isArray?: boolean;
  maxHeight?: number;
  filterOutMethod?: (obj: any) => boolean;
  options?: string;
  tagType?: TagType;
  optionNameField?: string;
  optionValueField?: string;
}

export interface AmountFilterValue {
  compareMethod?: CompareMethod;
  value1?: number | string;
  value2?: number | string;
  multiplicator?: number;
}

export enum CompareMethod {
  GT = 'gt',
  GTE = 'gte',
  LT = 'lt',
  LTE = 'lte',
  EQ = 'eq',
  NEQ = 'neq',
  IN = 'in',
  NIN = 'nin',
}

export type FilterValue = string | Array<any> | AmountFilterValue | undefined;
